import Grid from "./Grid";
import Totals from "./Totals";

export default {
  Grid,
  Totals
};
